// @ts-nocheck
import { useState } from "react";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { InputEmployeeByCenterCost } from "../../components/cards/InputEmployeeByCenterCost";
import { Map } from "../../components/map/Map";
import SelectDateGetDataEmployee from "../../components/cards/SelectDateGetDataEmployee";
import TableDataRoute from "../../components/cards/modal-data-route";
import useStore from "../../store/useStore";
import axios from "axios";
import { format } from "date-fns";
import { toast } from "sonner";
import { XCircle } from "@phosphor-icons/react";
import { InputPlacaCarro } from "../../components/map/InputPlacaCarro";
import { getInitialCardData, updateCardDataFromApi } from "../../utils/cardDataUtils";
import { CardGenerico } from "../../components/cards/CardGenerico";

export function TrackingByCostCenter() {
  const [isLoading, setIsLoading] = useState(false);
  const [cardData, setCardData] = useState(getInitialCardData());

  const { trackingDate, setGpsPings, selecionaPlacaCarro } = useStore((state) => state);

  const date = new Date(trackingDate);
  const formattedDate = format(date, "yyyy-MM-dd");

  // Componente de toast personalizado com ícone
  const ToastErro = ({ children }: { children: React.ReactNode }) => (
    <div className="flex items-center gap-2">
      <XCircle size={32} className="text-red-500" />
      <span>{children}</span>
    </div>
  );

  async function handleOnclick() {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const { data } = await axios.get(
        `https://radar.tlpservicos.com.br/api/map?placa=${selecionaPlacaCarro.value}&data=${formattedDate}`
      );

      // Verificar se há um message na resposta, indicando que não há dados
      if (data.message) {
        toast(<ToastErro>Não há dados para essa placa nesse dia</ToastErro>);
        return;
      }

      setGpsPings({
        allPings: [...(data.todos_os_pings ?? [])],
        pingsInsideClockIns: [...(data.pings_dentro_batida ?? [])],
        pingsOutsideClockIns: [...(data.pings_fora_batida ?? [])],
        clockIns: [...(data.batidas ?? [])],
        employeeHome: data.residencia_funcionario || null,
      });

      setCardData(updateCardDataFromApi(data));
    } catch (error) {
      console.error("ERRO", error);
      toast(<ToastErro>Erro ao buscar dados. Tente novamente mais tarde.</ToastErro>);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="w-full h-full grid grid-cols-7 overflow-hidden">
      <div className="col-span-2 flex flex-col gap-2 overflow-y-auto mx-2 max-h-full">
        <div className="h-16">
          <InputPlacaCarro />
        </div>
        <div className="h-16">
          <SelectDateGetDataEmployee />
        </div>
        <div className="h-16">
          <InputEmployeeByCenterCost />
        </div>
        <div>
          <button
            onClick={handleOnclick}
            type="submit"
            className="w-full border-2 border-blue-300 text-blue-300 text-md font-bold py-2 px-4 
                        rounded-md hover:bg-blue-300 hover:text-gray-500 transition duration-300 
                        tracking-wider uppercase disabled:cursor-not-allowed disabled:opacity-50
                        relative"
          >
            {isLoading ? (
              <>
                <span className="opacity-0">gerar rota</span>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-300"></div>
                </div>
              </>
            ) : (
              "gerar rota"
            )}
          </button>
        </div>
        <div>
          <TableDataRoute />
        </div>

        <div className="grid grid-cols-2 gap-2">
          {cardData.map((card, index) => (
            <div key={index}>
              <CardGenerico title={card.title} value={card.value} unit={card.unit} />
            </div>
          ))}
        </div>
      </div>

      <div className="col-span-5 h-full">
        <Map />
      </div>
    </div>
  );
}
